import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import ThanksPage from "./pages/ThanksPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/thanks" element={<ThanksPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
